<section class="dashboard">
  <div class="dashboard-main">
    <header class="dashboard-header">
      <div>
        <a class="back" routerLink="/drafts">‹ All drafts</a>
        <h1>{{ isGuest() ? "Guest cart" : "Customer cart" }}</h1>
        @if (draft(); as d) {
          <p class="subtitle">
            {{ isGuest() ? "Guest" : "Signed in" }} · {{ ownerLabel() }} ·
            {{ d.blindCount }} blind{{ d.blindCount === 1 ? "" : "s" }} ·
            {{ d.roomCount }} room{{ d.roomCount === 1 ? "" : "s" }}
          </p>
        }
        @if (recordingUrl()) {
          <a
            class="recording-link"
            [href]="recordingUrl()"
            target="_blank"
            rel="noopener"
          >
            ▶ Watch Clarity recording
          </a>
        }
      </div>
    </header>

    @if (loading()) {
      <div class="empty-state">Loading draft…</div>
    } @else if (!draft()) {
      <div class="empty-state">Draft not found. It may have expired.</div>
    } @else {
      @for (room of draft()!.rooms; track room.id) {
        <div class="room-card">
          <div class="room-head">
            <h2>{{ room.name || "Room" }}</h2>
            <span class="muted"
              >{{ room.windows.length }} window{{
                room.windows.length === 1 ? "" : "s"
              }}</span
            >
          </div>
          <div class="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Window</th>
                  <th>Style</th>
                  <th>Shading</th>
                  <th>Control</th>
                  <th class="num">Width (in)</th>
                  <th class="num">Height (in)</th>
                  <th class="num">Amount</th>
                </tr>
              </thead>
              <tbody>
                @for (w of room.windows; track w.id) {
                  <tr>
                    <td>{{ w.label || w.blindName || w.blindCode }}</td>
                    <td>{{ w.blindName || w.blindCode }}</td>
                    <td>{{ shadingLabel(w.opacity) }}</td>
                    <td>
                      {{ controlLabel(w.controlType)
                      }}{{ w.hasSolarPanel ? " · Solar" : "" }}
                    </td>
                    <td class="num">{{ w.width }}"</td>
                    <td class="num">{{ w.height }}"</td>
                    <td class="num">{{ money(w.price) }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }

      <div class="totals">
        <span>Cart total</span>
        <span class="total">{{ money(draft()!.total) }}</span>
      </div>
    }
  </div>
</section>
